import React, { useCallback, useState } from 'react'

import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaTimesCircle
} from 'react-icons/fa'
import { toast } from 'react-toastify'
import { EMULATOR_URL } from './constants.js'
import useFetch from './hooks/useFetch'

export const StatesContext = React.createContext({})

// FIXME: Need to get rid of this or somehow make these(need to check other states behavior. showToast is confirmed to cause rerenders)
// stop causing rerenders like showToast is causing

const useStates = () => {
  const {
    staticEmulators,
    isTableVisible,
    setIsTableVisible,
    isMoveDialogVisible,
    setIsMoveDialogVisible,
    hoveredMarker,
    setHoveredMarker,
    showToast,
    setSearchFor,
    searchFor,
    isTableGetSummary,
    setIsTableGetSummary
  } = React.useContext(StatesContext)
  return {
    staticEmulators,
    isTableVisible,
    setIsTableVisible,
    isMoveDialogVisible,
    setIsMoveDialogVisible,
    hoveredMarker,
    setHoveredMarker,
    showToast,
    setSearchFor,
    searchFor,
    isTableGetSummary,
    setIsTableGetSummary
  }
}

export { useStates }

export const StateProvider = ({ children }) => {
  const { data: staticEmulators } = useFetch(EMULATOR_URL)

  const [isMoveDialogVisible, setIsMoveDialogVisible] = useState(false)

  const [isTableVisible, setIsTableVisible] = useState(false)

  const [searchFor, setSearchFor] = useState('')

  const [hoveredMarker, setHoveredMarker] = useState(null)

  const [isTableGetSummary, setIsTableGetSummary] = useState(false)

  const typeToColor = {
    success: '#00C72E',
    error: '#FF3B30',
    info: '#2F80ED',
    warning: '#F2C94C'
  }

  const typeToIcon = {
    success: <FaCheckCircle style={{ color: typeToColor.success }} />,
    error: <FaTimesCircle style={{ color: typeToColor.error }} />,
    info: <FaInfoCircle style={{ color: typeToColor.info }} />,
    warning: <FaExclamationTriangle style={{ color: typeToColor.warning }} />
  }

  const showToast = useCallback((message, type) => {
    toast[type](message, {
      icon: typeToIcon[type],
      progressStyle: { backgroundColor: typeToColor[type] }
    })
  }, [])

  return (
    <StatesContext.Provider
      value={{
        staticEmulators,
        isTableVisible,
        setIsTableVisible,
        isMoveDialogVisible,
        setIsMoveDialogVisible,
        hoveredMarker,
        setHoveredMarker,
        showToast,
        setSearchFor,
        searchFor,
        isTableGetSummary,
        setIsTableGetSummary
      }}
    >
      {children}
    </StatesContext.Provider>
  )
}
